<div class="submissions page-holder bg-gray-100">
    <div class="container-fluid px-lg-4 px-xl-5 min-w-viewport">
      <!-- Page Header-->
      <div class="page-header d-flex justify-content-between align-items-center">
        <h1 class="page-heading">View Submissions</h1>
      </div>
      
      <div class="row mb-5">
        <div class="form-group">
            <input type="text" class="form-control mb-4" placeholder="Search" [(ngModel)]="query" id="submissionSearch">
          </div>
        <div class="col-md-4 mb-4" *ngFor="let row of submissionsData | freetextSearch: query">
            <div class="card h-100">
              <div class="card-header"> 
                <h6 class="card-heading mb-1">{{row.title}}</h6>
                <div class="form-tags">
                    <span class="badge badge-success-light me-2">{{row.buName}}</span>
                    <span class="badge badge badge-info-light">{{row.facilityName}}</span>
                </div>  
              </div>
              <div class="card-body cursor-pointer">
                <div>Submitted By : {{row.submittedBy}} @ {{row.submittedDate}}</div>
              </div>
            
            </div>
        </div>
      </div>
    </div>
    <div *ngIf="httpService.processing()">
        <app-progress-indicator></app-progress-indicator>
      </div>
    <app-footer class="footer-w"></app-footer>
  </div>